
import { getPath } from '@/router/common'

const baseUrl = {
  title: '通讯中心',
  path: 'SystemAlert'
}
export default [
  {
    path: getPath('Index', baseUrl),
    name: 'SystemAlert',
    component: () => import(/* webpackChunkName: "SystemAlert" */ '@/views/systemAlert/systemAlert/index.vue'),
    meta: {
      title: '系统提醒管理'
    }
  }
]
